import { render, staticRenderFns } from "./caruselWrapper.vue?vue&type=template&id=d985e054&scoped=true&"
import script from "./caruselWrapper.vue?vue&type=script&lang=js&"
export * from "./caruselWrapper.vue?vue&type=script&lang=js&"
import style0 from "./caruselWrapper.vue?vue&type=style&index=0&id=d985e054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d985e054",
  null
  
)

export default component.exports